import * as types from '../../actions/types';

const initialState = []

export default function disciplines (state = initialState, action) {
  switch (action.type) {
    
    case types.COMPLEX_TOPICS_DISCIPLINES_GET_DISCIPLINES:
      return action.disciplines
    
    default:
      return state;
  }
}
